export const UTRAKK_AUTH_PROVIDER = 'utrakk'
export const UTRAKK_DOMAIN_HINT = import.meta.env.VITE_UTRAKK_DOMAIN_HINT || 'utrakk'

function fallbackRedirectUri() {
  if (typeof window !== 'undefined' && window.location?.origin)
    return `${window.location.origin}/login-processing`

  return '/login-processing'
}

function optionalEnvironment(value) {
  return typeof value === 'string' && value.trim() ? value.trim() : undefined
}

export function resolveUtrakkLoginRedirectUri() {
  return optionalEnvironment(import.meta.env.VITE_UTRAKK_LOGIN_REDIRECT_URI)
    || fallbackRedirectUri()
}

export const UTRAKK_LOGIN_REDIRECT_URI = resolveUtrakkLoginRedirectUri()

export function normalizeUtrakkLoginHint(rawEmail) {
  return rawEmail?.trim() || ''
}

export function createUtrakkMsalLoginRequest(rawEmail) {
  const loginHint = normalizeUtrakkLoginHint(rawEmail)
  const redirectUri = resolveUtrakkLoginRedirectUri()
  const request = {
    scopes: ['openid', 'profile', 'offline_access'],
    extraQueryParameters: {
      domain_hint: UTRAKK_DOMAIN_HINT,
    },
    redirectUri,
    redirectStartPage: redirectUri,
  }

  if (loginHint)
    request.loginHint = loginHint

  return request
}
